import React from "react";

import "./Branches.css";

import Container from "../Container";

import Branch from "./Branch";



const Branches = () => {

  return (

    <Container>

      <section className="branches">

        <div className="branches-title">

          <div className="b-title">Sucursales</div>

          <div className="b-description">

            SUCURSALES A SU DISPOSICIÓN EN TODO EL PAÍS

          </div>

        </div>

        <div className="branches-items">

          <Branch

            location="Centro de Diagnóstico"

            descriptions={[

              "75 metros al norte de la terminal de buses Tracopa"

            ]}

            mapsLink="https://maps.app.goo.gl/L2ssHqjUNb2zoyQ67?g_st=aw"

            wazeLink="https://waze.com/ul/hd1u0qz0e3"

          />

          <Branch

            location="Cartago Centro"

            descriptions={[

              "Frente a los Bomberos de Costa Rica"

            ]}

            mapsLink="https://maps.app.goo.gl/QxG6w35DVovikBFr9"

            wazeLink="https://waze.com/ul/hd1u247bwu"

          />

          <Branch

            location="Alajuela"

            descriptions={[

              "75 metros Sur los semáforos de la Corte"

            ]}

            mapsLink="https://maps.app.goo.gl/v1q4DhYCeS4hbzJe7"

            wazeLink="https://waze.com/ul/hd1u158h25"

          />

          <Branch

            location="Guadalupe"

            descriptions={[

              "75 metros Este de la Musmanni"

            ]}

            mapsLink="https://maps.app.goo.gl/r8gcMThBcjQm311G7"

            wazeLink="https://waze.com/ul/hd1u0x6d40"

          />

          <Branch

            location="San Ramón"

            descriptions={[

              "50 metros al Este de Tiendas Ekono"

            ]}

            mapsLink="https://maps.app.goo.gl/6sqne8zctDrXMHvE7?g_st=ipc"

            wazeLink=""

          />

          <Branch

            location="El Roble, Puntarenas"

            descriptions={[

              "Frente al Banco de Costa Rica"

            ]}

            mapsLink="https://maps.app.goo.gl/rzcFaFjigTdmzKaeA"

            wazeLink="https://waze.com/ul/hd1g8zbdrz"

          />

          <Branch

            location="Cañas"

            descriptions={[

              "Frente al Banco Nacional"

            ]}

            mapsLink="https://maps.app.goo.gl/YGJwaYcvYuo9p1MZ8"

            wazeLink="https://ul.waze.com/ul?place=ChIJUQLdDRb7n48RJt_Ih61KNrk&ll=10.42695560%2C-85.09126830&navigate=yes&utm_campaign=default&utm_source=waze_website&utm_medium=lm_share_location"

          />

          <Branch

            location="Tres Ríos"

            descriptions={[

              "50 metros Este del Mas x Menos, Edificio Sabino Guzmán frente a Plaza Estación"

            ]}

            mapsLink="https://maps.app.goo.gl/snxLcuiVD6LjVmMaA"

            wazeLink="https://waze.com/ul/hd1u22gc9y"

          />

          <Branch

            location="Liberia"

            descriptions={[

              "75 metros Oeste de Correos de Costa Rica, frente a Ferretería San Carlos"

            ]}

            mapsLink="https://maps.app.goo.gl/8Ea1KMaSgdMzcMbe9"

            wazeLink=""

          />

          <Branch

            location="Heredia"

            descriptions={[

              "Banco Popular del Liceo, 75 metros al Este"

            ]}

            mapsLink="https://maps.app.goo.gl/A4py8Zf1Aew1T22i9"

            wazeLink="https://waze.com/ul/hd1u0vujwn"

          />

          <Branch

            location="Sucursal Barrio Dent: Los Yoses"

            descriptions={[

              "300 al norte de Ambacar, Centro médico Bonanza"

            ]}

            mapsLink="https://www.google.com/maps/search/Clinica+Studio+Visual+Barrio+Dent+Los+Yoses+Costa+Rica"

            wazeLink="https://www.waze.com/search?q=Clinica%20Studio%20Visual%20Barrio%20Dent%20Los%20Yoses"

          />

          <Branch

            location="Guápiles"

            descriptions={[

              "Plaza Comercial Guápiles, contiguo a Subway"

            ]}

            mapsLink="https://maps.app.goo.gl/4WNDe1Z3Dx2zVi978"

            wazeLink="https://ul.waze.com/ul?preview_venue_id=181010534.1810170878.19879810&navigate=yes&utm_campaign=default&utm_source=waze_website&utm_medium=lm_share_location"

          />

          <Branch

            location="Nicoya"

            descriptions={[

              "300 metros Norte de Hospital La Anexión, diagonal a Ekono, frente al Colono Agropecuario"

            ]}

            mapsLink="https://maps.app.goo.gl/QH7YaXtykoSpyifc9"

            wazeLink="https://waze.com/ul/hd1g1z80rd"

          />

          <Branch

            location="San Carlos"

            descriptions={[

              "Barrio San Roque, frente a la Iglesia Católica"

            ]}

            mapsLink="https://maps.app.goo.gl/ywGTNXK9CswKmeSv6"

            wazeLink="https://waze.com/ul/hd1gfy8qc2"

          />

          <Branch

            location="San José Av8"

            descriptions={[

              "Del Diario Extra 200 metros al Sur y 25 metros Este sobre Av8"

            ]}

            mapsLink="https://maps.app.goo.gl/CS7ctqsouabyYnkN8"

            wazeLink="https://ul.waze.com/ul?place=ChIJo6qagl3joI8Rdgv6XSvqYeE"

          />

          <Branch

            location="Escazú"

            descriptions={[

              "100 metros Norte del parque, contiguo a POPS"

            ]}

            mapsLink="https://www.google.com/maps/search/Clinica+Studio+Visual+Escazu+Costa+Rica"

            wazeLink="https://waze.com/ul/hd1u0mq47r"

          />

          <Branch

            location="Desamparados"

            descriptions={[

              "150 mts al Este de la Municipalidad, contiguo a ExtremeTech"

            ]}

            mapsLink="https://www.google.com/maps/search/Clinica+Studio+Visual+Desamparados+Costa+Rica"

            wazeLink="https://www.waze.com/search?q=Clinica%20Studio%20Visual%20Desamparados"

          />

          <Branch

            location="Mall Paseo de las Flores"

            descriptions={[

              "Segundo piso - Fil óiso o RadiShack, Frente de Lelevonterd"

            ]}

            mapsLink="https://www.google.com/maps/search/Clinica+Studio+Visual+Paseo+de+las+Flores+Costa+Rica"

            wazeLink="https://www.waze.com/search?q=Clinica%20Studio%20Visual%20Paseo%20de%20las%20Flores"

          />

          <Branch

            location="Grecia"

            descriptions={[

              "Costado del parque, contiguo a Taquería Los Pira"

            ]}

            mapsLink="https://www.google.com/maps/search/Clinica+Studio+Visual+Grecia+Costa+Rica"

            wazeLink=""

          />

          <Branch

            location="Pérez Zeledón"

            descriptions={[

              "50 oeste de La Casa de la Juventud, esquina Clínica San Lucas diagonal al parqueo de Pali"

            ]}

            mapsLink="https://maps.app.goo.gl/ugq6WM3yviR2mhWM7"

            wazeLink="https://waze.com/ul/hd1smr3ber"

          />

        </div>

        <div className="schedule">

          Lunes a Sábado: 9:00 am a 6:00 pm | Paseo de las Flores: abierto domingos de 10:00 am a 8:00 pm

        </div>

      </section>

    </Container>

  );

};



export default Branches;


